import { App, Modal, TimePicker, Form, Input, Select, notification, DatePicker, Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { apis, models } from '@vote4dance/judging-sdk';
import { _T } from '../../../../../base-react/src/Localization';
import dayjs from 'dayjs';
var Api = apis.Api;
var ScheduleSource = models.schedules.ScheduleSource;
var ScheduleRoundSource = models.rounds.ScheduleRoundSource;
import { useParams } from 'react-router-dom';
const timeFormat = 'HH:mm';
const dateFormat = 'YYYY-MM-DD';
export const ScheduleItemEdit = (props) => {
    const { event_id, isPage, schedule, scheduleItem, visible, setVisible, pageChildren, disabled } = props;
    const { page_id } = useParams();
    const { modal } = App.useApp();
    const [isLoading, setIsLoading] = React.useState(false);
    const [form] = Form.useForm();
    const scheduleSource = ScheduleSource(event_id);
    const [currentItem, setCurrentItem] = useState();
    const textInputRef = useRef(null);
    useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = textInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    }, [visible]);
    useEffect(() => {
        setCurrentItem(scheduleItem);
    }, [scheduleItem]);
    useEffect(() => {
        form.resetFields();
    }, [currentItem]);
    const onFinish = (fieldsValue) => {
        setIsLoading(true);
        form
            .validateFields()
            .then(fieldsValue => {
            const updateItem = {
                ...currentItem,
                ...fieldsValue,
                schedule_value: fieldsValue['schedule_value'] ? fieldsValue['schedule_value'] : _T('common.empty'),
                schedule_date: fieldsValue['schedule_date'] ? fieldsValue['schedule_date'].format(dateFormat) : null,
                schedule_start_time: fieldsValue['schedule_start_time'] ? fieldsValue['schedule_start_time'].format(timeFormat) : null
            };
            if (currentItem) {
                Api.update(`${scheduleSource.url}/${currentItem.schedule_id}`, updateItem)
                    .then(() => {
                    form.resetFields();
                    setIsLoading(false);
                    setVisible(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.name
                    });
                });
            }
            else {
                Api.create(scheduleSource.url, updateItem)
                    .then((result) => {
                    if (schedule && !isPage) {
                        const lastItem = pageChildren && pageChildren[pageChildren.length - 1];
                        const insertAfterId = lastItem ? lastItem.schedule_id : scheduleItem ? scheduleItem.schedule_id : page_id;
                        const allScheduleIds = schedule.map((e) => e.schedule_id);
                        const insertIndex = allScheduleIds.indexOf(insertAfterId);
                        allScheduleIds.splice(insertIndex + 1, 0, result.schedule_id);
                        const scheduleSource = ScheduleSource(event_id);
                        return Api.call(scheduleSource.url, "set-order", allScheduleIds);
                    }
                    return true;
                })
                    .then(() => {
                    form.resetFields();
                    setIsLoading(false);
                    setVisible(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.message
                    });
                });
            }
        })
            .catch(info => {
            setIsLoading(false);
        });
    };
    const handleCancel = () => {
        if (!isLoading) {
            form.resetFields();
            setVisible(false);
        }
    };
    const handleDelete = () => {
        if (!currentItem) {
            return;
        }
        if (isPage) {
            const pageBreakCount = (schedule !== null && schedule !== void 0 ? schedule : []).filter((item) => item.schedule_type === 'break').length;
            if (pageBreakCount <= 1) {
                modal.error({
                    title: _T('schedule.warnings.minimumPages.title'),
                    content: _T('schedule.warnings.minimumPages.content')
                });
                return;
            }
        }
        if (isPage && pageChildren && pageChildren.length > 0) {
            modal.error({
                title: _T('schedule.warnings.removeItemsBeforeDelete.title'),
                content: _T('schedule.warnings.removeItemsBeforeDelete.content'),
            });
            return;
        }
        const scheduleRoundSource = ScheduleRoundSource(event_id, currentItem.schedule_id);
        modal.confirm({
            title: _T('common.delete.title', { name: _T('schedule.title').toLowerCase() }),
            content: _T('common.delete.content', { name: currentItem.schedule_value }),
            onOk() {
                setIsLoading(true);
                Api.read(scheduleRoundSource.url)
                    .then((rounds) => {
                    if (Array.isArray(rounds) && rounds.length > 0) {
                        modal.error({
                            title: _T('schedule.warnings.removeRoundsBeforeDelete.title'),
                            content: _T('schedule.warnings.removeRoundsBeforeDelete.content'),
                        });
                        setIsLoading(false);
                    }
                    else {
                        Api.destroy(`${scheduleSource.url}/${currentItem.schedule_id}`)
                            .then(() => {
                            setIsLoading(false);
                            handleCancel();
                        })
                            .catch((err) => {
                            setIsLoading(false);
                            notification.error({
                                message: err.name
                            });
                        });
                    }
                })
                    .catch((err) => {
                    notification.error({
                        message: err.name
                    });
                });
            }
        });
    };
    const onOk = () => {
        form.submit();
    };
    const formName = currentItem ? `schedule_${currentItem.schedule_id}_item_settings` : `schedule_new_${event_id}_item_settings`;
    return (React.createElement(Modal, { title: _T('schedule.' + (isPage ? 'page.title' : 'details.title')), open: visible, onCancel: handleCancel, footer: [
            currentItem &&
                React.createElement(Button, { key: "delete", type: "dashed", disabled: isLoading, onClick: handleDelete, danger: true }, _T('common.delete.title')),
            React.createElement(Button, { key: "cancel", disabled: isLoading, onClick: handleCancel }, _T('common.cancel.title')),
            React.createElement(Button, { key: "submit", type: "primary", form: formName, htmlType: 'submit', disabled: isLoading, loading: isLoading, onClick: onOk }, _T('common.save')),
        ] },
        React.createElement(Form, { name: formName, form: form, disabled: disabled, onFinish: onFinish, initialValues: {
                schedule_date: currentItem && currentItem.schedule_date ? dayjs(currentItem.schedule_date, dateFormat) : null,
                schedule_start_time: currentItem && currentItem.schedule_start_time ? dayjs(currentItem.schedule_start_time, timeFormat) : null,
                schedule_value: currentItem && currentItem.schedule_value,
                schedule_type: currentItem && currentItem.schedule_type ? currentItem.schedule_type : isPage ? 'break' : 'label',
                schedule_access_level: currentItem && currentItem.schedule_access_level ? currentItem.schedule_access_level : 0
            } },
            React.createElement(Form.Item, { name: "schedule_value" },
                React.createElement(Input, { ref: textInputRef, disabled: isLoading, allowClear: true, onPressEnter: onFinish, placeholder: _T('schedule.' + (isPage ? 'page.' : '') + 'details.schedule_value.placeholder') })),
            React.createElement(Form.Item, { name: "schedule_date", hidden: !isPage },
                React.createElement(DatePicker, { disabled: isLoading, format: dateFormat })),
            React.createElement(Form.Item, { name: "schedule_start_time", hidden: isPage },
                React.createElement(TimePicker, { disabled: isLoading, format: timeFormat })),
            React.createElement(Form.Item, { name: "schedule_type", hidden: isPage },
                React.createElement(Select, { disabled: isLoading },
                    React.createElement(Select.Option, { value: "label" }, _T('schedule.details.schedule_type.label')),
                    React.createElement(Select.Option, { value: "comment" }, _T('schedule.details.schedule_type.comment')))),
            React.createElement(Form.Item, { name: "schedule_access_level", hidden: isPage },
                React.createElement(Select, { disabled: isLoading },
                    React.createElement(Select.Option, { value: 0 }, _T('schedule.details.schedule_access_level.0')),
                    React.createElement(Select.Option, { value: 1 }, _T('schedule.details.schedule_access_level.1')))))));
};
